import React from "react";
import RadioButton from "../../components/radioButtons/RadioButton";
import Input from "../../components/inputs/Input";
import Checkbox from "../../components/checkboxes/Checkbox";
import Textarea from "../../components/inputs/Textarea";
import TypesContext from "../../contexts/types";
import Button from "../../components/buttons/Button";
import ImageUpload from "../../components/uploads/ImageUpload";

export default ({ data, setData, errors, setError, next, btnLabel, saved }) => {
  const { skills } = React.useContext(TypesContext);

  const verifyData = () => {
    setError();
    let isOkay = true;
    if (!data["name"]) {
      setError({ field: "name", message: "Please provide a correct name" });
      isOkay = false;
    }
    if (!data["job"]) {
      setError({ field: "job", message: "Please provide a correct job" });
      isOkay = false;
    }
    if (isOkay) next();
  };

  return (
    <div className="oUserForm">
      <h3>About</h3>
      <div className="oUserForm_imageUpload">
        <ImageUpload
          avatar
          label="Upload profile picture"
          notice="JPG or PNG, max 200 Ko"
          currentImage={data["avatar"]}
          setFile={value => setData({ field: "avatar", value })}
        />
      </div>
      <div className="oUserForm_inputs">
        <Input
          label="First and last name or organization’s name"
          required
          value={data["name"]}
          setValue={value => setData({ field: "name", value })}
          error={errors.some(({ field }) => field === "name")}
        />
        <Input
          label="Job title"
          required
          max={30}
          notice="e.g., Professor, PhD, Postdoc, Engineer, CEO, founder,..."
          value={data["job"]}
          setValue={value => setData({ field: "job", value })}
          error={errors.some(({ field }) => field === "job")}
        />
      </div>
      <h4>Skills</h4>
      <div className="oUserForm_list">
        {skills &&
          skills.map(skill => (
            <Checkbox
              key={skill.id}
              label={skill.name}
              checked={data["skill"] && data["skill"].includes(skill.id)}
              setValue={() =>
                setData({
                  field: "skill",
                  value: skill.id,
                  type: "skill",
                })
              }
            />
          ))}
      </div>
      <h4>Experience</h4>
      <div className="oUserForm_list">
        <RadioButton
          name="level"
          value={1}
          label="Student"
          checked={data["level"] === "1"}
          setValue={value => setData({ field: "level", value })}
        />
        <RadioButton
          name="level"
          value={2}
          label="0-5 years"
          checked={data["level"] === "2"}
          setValue={value => setData({ field: "level", value })}
        />
        <RadioButton
          name="level"
          value={3}
          label="+5 years"
          checked={data["level"] === "3"}
          setValue={value => setData({ field: "level", value })}
        />
      </div>
      <div className="oUserForm_bio">
        <Textarea
          label="Bio"
          max={200}
          placeholder="Write some words about you..."
          value={data["bio"]}
          setValue={value => setData({ field: "bio", value })}
        />
      </div>
      {saved ? (
        <Button big green full>
          Saved !
        </Button>
      ) : (
        <Button onClick={verifyData} big full>
          {btnLabel || "Continue"}
        </Button>
      )}
    </div>
  );
};
